<template>
    <div class="row pt-4" v-show="aItems.length > 0">
        <div class="col-12 mobile-title" :class=" !isMobile ? 'py-3' : 'pt-2 pb-3'">
            <span class="fs-30 fw-300 color-primary-n">Últimos publicados</span>
        </div>

        <div class="col-12" v-if="!isLoadingData && !isMobile">
            <div class="items-card-container">
                <app-item-card-c v-for="(item, index) in aItems"
                                 :item="item"
                                 :key="'lt_' + index">
                </app-item-card-c>
            </div>
        </div>

        <div class="col-12" v-if="!isLoadingData && isMobile">
            <app-item-card-c v-for="(item, index) in aMobileItems"
                                :item="item"
                                :key="'lt_' + index">
            </app-item-card-c>

            <div class="load-more-button" @click="loadMoreItems()" v-if="aItems.length != aMobileItems.length">Cargar más...</div>
        </div>

        <div class="col-12 text-center">
            <loader-c :absolute="false"
                      v-if="isLoadingData">
            </loader-c>
        </div>
    </div>
</template>

<script>
import filtersMixin from '../../../mixins/filtersMixin';
import fileRootPathMixin from '../../../mixins/fileRootPathMixin';
import itemMainImageMixin from '../../../mixins/itemMainImageMixin';

import LoaderC from '../../Shared/General/LoaderComponent.vue';
import AppItemCardC from '../Inventory/ItemCardComponent.vue';

import { checkCatch, showMessage } from '../../../utils';

const INITIAL_LATEST_ITEMS_TO_SHOW = 3;
const LOAD_MORE_LATEST_ITEMS = 2;

export default {

    components: {

        LoaderC,
        AppItemCardC,

    },

    mixins: [

        filtersMixin,
        fileRootPathMixin,
        itemMainImageMixin,

    ],

    data() {

        return {

            isLoadingData: true,

            aItems: [],

            aMobileItems: [],

        };

    },

    mounted() {

        this.loadLatestItems();

    },

    methods: {

        loadLatestItems() {

            axios
                .get('/inventory/items/latest')
                .then((response) => {

                    const { data } = response;

                    if (!data.success) {

                        showMessage('error', 'Atención', data.message);
                        return;

                    }

                    this.aItems = data.data.map((item) => {

                        item.mainImage = this.getItemMainImage(item);

                        return item;

                    });

                    if (this.isMobile) {

                        this.aMobileItems = this.aItems.slice(0, INITIAL_LATEST_ITEMS_TO_SHOW);

                    }

                    setTimeout(() => {

                        this.isLoadingData = false;

                    }, 500);

                })
                .catch((error) => {

                    checkCatch(error);

                });

        },

        loadMoreItems() {

            const moreItems = this.aItems.slice(this.aMobileItems.length, this.aMobileItems.length + LOAD_MORE_LATEST_ITEMS);
            this.aMobileItems = this.aMobileItems.concat(moreItems);

        },

    },

};
</script>
